import { gql } from '@apollo/client';
import { NamedFilterFragment } from '../../../utils/apollo/filters';

export default gql`
  query GetNamedFilters(
    $schemaId: ID!
    $term: String
    $includeIds: [ID!]!
    $pagination: Pagination!
  ) {
    namedFilters(
      schemaId: $schemaId
      includes: $includeIds
      term: $term
      pagination: $pagination
    ) {
      entities {
        ...NamedFilterFields
      }
    }
  }
  ${NamedFilterFragment}
`;
